/** Canonical product identity shared by every distributed surface. */
export const PRODUCT_NAME = "Kuroo CRM" as const;
export const SHORT_NAME = "Kuroo" as const;
export const BOOKING_ELEMENT_NAME = "kuroo-booking" as const;
export const SESSION_COOKIE_NAME = "kuroo_session" as const;
export const API_PREFIX = "/api/v1" as const;

export const BRAND_COLORS = {
  graphite: "#0B1020",
  violet: "#6D5EF8",
  cyan: "#22D3EE",
  ink: "#101828",
  surface: "#F7F8FC",
  border: "#D7DCEF"
} as const;

/** Curated brand choices used by the public editor. Each primary keeps AA
 * contrast with the light surface; dark mode derives its lighter semantic
 * variant from the same base token. */
export const BRAND_PRIMARY_COLORS = [
  "#6D5EF8", "#4F46E5", "#4338CA", "#7C3AED", "#5B21B6",
  "#0F766E", "#0F5B78", "#1D4ED8", "#9F1239"
] as const;

/** Accent choices are used for supporting signals and decorative surfaces. */
export const BRAND_ACCENT_COLORS = [
  "#22D3EE", "#2DD4BF", "#60A5FA", "#A78BFA", "#F472B6", "#F59E0B"
] as const;

export const BRAND_TOKENS = `:root{--kuroo-graphite:${BRAND_COLORS.graphite};--kuroo-violet:${BRAND_COLORS.violet};--kuroo-cyan:${BRAND_COLORS.cyan};--kuroo-ink:${BRAND_COLORS.ink};--kuroo-surface:${BRAND_COLORS.surface};--kuroo-border:${BRAND_COLORS.border}}`;
